import * as React from 'react';
import classnames from "classnames";

import { EditServiceAccountActions } from "./EditServiceAccountActions";
import { EditServiceAccountStoreState } from "./EditServiceAccountStore";
import { DivisionSelector } from "../../DivisionSelector";
import { LoadableGroup, InputTextGroup, CheckboxGroup } from "../../Forms/Groups";
import { Polyglot } from '../../../../polyglot';

const styles = require('./NewServiceAccount.scss');
interface FormProps
{
    polyglot: Polyglot;
    loadDivisionsInProgress: boolean;
}

type Props = Partial<EditServiceAccountStoreState> & Partial<EditServiceAccountActions> & FormProps;
export class NewServiceAccount extends React.Component<Props>
{
    render ()
    {
        const { draft,
            loadDivisionsInProgress, divisions, setDivision,
            polyglot,
        } = this.props;

        return (
            <div className={classnames("form-horizontal", styles.NewServiceAccount)}>
                <LoadableGroup title={polyglot.t('service_account.label_division') + ':'} isLoading={loadDivisionsInProgress} value={draft.Division}>
                    <DivisionSelector divisions={divisions} onChange={setDivision} selectedId={draft.DivisionId} />
                </LoadableGroup>
                <InputTextGroup title={polyglot.t('service_account.label_server_url') + ':'} value={draft.ServerUrl || ''} onChange={e => this.props.setServerUrl(e.target.value)} />
                <InputTextGroup title={polyglot.t('service_account.label_username') + ':'} value={draft.Username || ''} onChange={e => this.props.setLogin(e.target.value)} />
                <InputTextGroup title={polyglot.t('service_account.label_password') + ':'} value={draft.Password || ''} onChange={e => this.props.setPassword(e.target.value)} />
                <CheckboxGroup title={polyglot.t('service_account.label_import_vehicles')} checked={draft.AutoImport} onChange={e => this.props.setImportAllVehicles(e.target.checked)} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/ServiceAccount/NewServiceAccount.tsx